module.exports = __webpack_public_path__ + "img/30.971149b6.png";